import IntlTelInput, { CountryData } from "react-intl-tel-input";
import styled from "styled-components";

import { StyledError } from "@components";
import { FormikErrors } from "formik";
import { IEmailForm, IPhone, IUserSetting } from "@interfaces";
import { TelIcon } from "../icon";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectApp } from "@redux";
import { useEffect, useState } from "react";

interface IProps {
    setFieldTouched: (
        field: string,
        touched?: boolean | undefined,
        shouldValidate?: boolean | undefined
    ) => Promise<void> | Promise<FormikErrors<IUserSetting | IEmailForm | IPhone>>;
    value: string;
    errorPhone: string;
    disabled?: boolean | undefined;
    country: string | undefined;
    handleChangePhoneNumber: (
        isValid: boolean,
        value: string,
        selectedCountryData: CountryData,
        fullNumber: string
    ) => void;
    handleSelectFlag: (
        currentNumber: string,
        selectedCountryData: CountryData,
        fullNumber: string
    ) => void;
}

export const SharedIntlTelInput = (props: IProps) => {
    //page props
    const {
        setFieldTouched,
        value,
        errorPhone,
        disabled,
        country,
        handleChangePhoneNumber,
        handleSelectFlag,
    } = props;
    const { t } = useTranslation();
    const { langSetting } = useSelector(selectApp);
    const [preferLang, setPreferLang] = useState<string[]>([]);
    useEffect(() => {
        if (langSetting?.flag !== "") {
            let prelang = ["th"];
            if (langSetting?.flag !== "th") {
                prelang.push((langSetting?.flag).toString());
            }
            setPreferLang(prelang);
        }
    }, [langSetting]);
    return (
        <StyledLayout>
            {preferLang.length !== 0 &&
                <StyledIntlTelInput
                    defaultCountry={langSetting?.flag}
                    preferredCountries={preferLang}
                    fieldId="phoneNumber"
                    fieldName="phoneNumber"
                    onPhoneNumberChange={handleChangePhoneNumber}
                    onPhoneNumberBlur={() => {
                        setFieldTouched(value || "", true);
                    }}
                    onSelectFlag={handleSelectFlag}
                    value={value}
                    disabled={disabled}
                    autoFocus={true}
                    formatOnInit={false}
                    placeholder={t("page.phone_number_placeholder")}
                />
            }

            {/* <StyledTelIconLayout>
                <TelIcon />
            </StyledTelIconLayout> */}
            {errorPhone && (
                <StyledError className="custom-error" visible={true}>
                    {errorPhone}
                </StyledError>
            )}
        </StyledLayout>
    );
};

const StyledTelIconLayout = styled.div`
    position: absolute;
    top: 10px;
    left: 8px;
    background-color: ${(p) => p.theme.colors.card};
    z-index: 2;
    width: 40px;
    height: 30px;
`;
const StyledLayout = styled.div`
    position: relative;
`;

const StyledIntlTelInput = styled(IntlTelInput)`
    input.allow-dropdown input[type="tel"] {
        border-radius: 6px;
    }
`;
